import { Attachment } from "@/store/chats/types";

export const getIsMessageHidden = (
  messageText: string,
  attachments: Attachment[] = [],
) => {
  return !messageText && !attachments?.length;
};
